module.exports = __webpack_public_path__ + "img/me3.67216598.gif";